export const ValidGender = ["m", "f", "x", "other"];
export const ValidAgeRanges = [
  "under18",
  "18-24",
  "25-34",
  "35-44",
  "45-54",
  "55-64",
  "65plus",
];
